module.exports = __webpack_public_path__ + "img/button_citylife.72ccf238.png";